const frWeekdays = [
  "Dimanche",
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];

const frMonths = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

const formatCsvDate = (d: Date) => `${d.getDate()}-${frMonths[d.getMonth()]}`;

const addDays = (date: Date, days: number) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

function buildWeekHeader(title: string) {
  const header1 = [title].join(";");
  const header2 = [
    "",
    "Date",
    "Chambres à vendre",
    "Taux d'occupation",
    "Chambres vendues",
  ].join(";");
  return { header1, header2 };
}

export function buildPrevisionsCsvTemplate(startDate: Date): string {
  const lines: string[] = [];
  // Week 1
  const { header1: w1h1, header2: w1h2 } = buildWeekHeader("Semaine 1");
  lines.push(w1h1, w1h2);
  for (let i = 0; i < 7; i++) {
    const d = addDays(startDate, i);
    const weekday = frWeekdays[d.getDay()];
    const dateLabel = formatCsvDate(d);
    lines.push([weekday, dateLabel, "", "", ""].join(";"));
  }
  lines.push("");
  // Week 2
  const { header1: w2h1, header2: w2h2 } = buildWeekHeader("Semaine 2");
  lines.push(w2h1, w2h2);
  for (let i = 0; i < 7; i++) {
    const d = addDays(startDate, 7 + i);
    const weekday = frWeekdays[d.getDay()];
    const dateLabel = formatCsvDate(d);
    lines.push([weekday, dateLabel, "", "", ""].join(";"));
  }
  return lines.join("\n");
}

export type ForecastWeekData = { [day: number]: { chambresAVendre?: number; chambresVendues?: number } };

export function buildPrevisionsCsvExport(
  startDate: Date,
  week1: ForecastWeekData,
  week2: ForecastWeekData
): string {
  const lines: string[] = [];
  const emitWeek = (title: string, offset: number, week: ForecastWeekData) => {
    const { header1, header2 } = buildWeekHeader(title);
    lines.push(header1, header2);
    for (let i = 0; i < 7; i++) {
      const d = addDays(startDate, offset + i);
      const weekday = frWeekdays[d.getDay()];
      const dateLabel = formatCsvDate(d);
      const av = week[i]?.chambresAVendre ?? 0;
      const v = week[i]?.chambresVendues ?? 0;
      const pct = av > 0 ? Math.round((v / av) * 100) : "";
      lines.push([weekday, dateLabel, av, pct, v].join(";"));
    }
  };
  emitWeek("Semaine 1", 0, week1);
  lines.push("");
  emitWeek("Semaine 2", 7, week2);
  return "\uFEFF" + lines.join("\n");
}
